export const LOGIN_REQUEST  = "user/LOGIN_REQUEST"
export const LOGIN_RECEIVED = "user/LOGIN_RECEIVED"
export const LOGIN_ERROR    = "user/LOGIN_ERROR"

export const TOKEN_REQUEST  = "user/TOKEN_REQUEST"
export const TOKEN_RECEIVED = "user/TOKEN_RECEIVED"
export const TOKEN_ERROR    = "user/TOKEN_ERROR"

export const SIGNUP_REQUEST  = "user/SIGNUP_REQUEST"
export const SIGNUP_RECEIVED = "user/SIGNUP_RECEIVED"
export const SIGNUP_ERROR    = "user/SIGNUP_ERROR"

export const CHANGE_PASSWORD_REQUEST  = "user/CHANGE_PASSWORD_REQUEST"
export const CHANGE_PASSWORD_RECEIVED = "user/CHANGE_PASSWORD_RECEIVED"
export const CHANGE_PASSWORD_ERROR    = "user/CHANGE_PASSWORD_ERROR"

export const RESET_PASSWORD_REQUEST  = "user/RESET_PASSWORD_REQUEST"
export const RESET_PASSWORD_RECEIVED = "user/RESET_PASSWORD_RECEIVED"
export const RESET_PASSWORD_ERROR    = "user/RESET_PASSWORD_ERROR"

export const DELETE_PROFILE_REQUEST  = "user/DELETE_PROFILE_REQUEST"
export const DELETE_PROFILE_RECEIVED = "user/DELETE_PROFILE_RECEIVED"
export const DELETE_PROFILE_ERROR    = "user/DELETE_PROFILE_ERROR"

export const LOGOUT  = "user/LOGOUT"



/** WEBPACK FOOTER **
 ** ./src/actions/user/types.js
 **/